import { combineReducers } from 'redux';

import { prefillOrderInputsReducer } from './prefillOrderInputs';

export const ordersReducer = combineReducers({
  prefillOrderInputs: prefillOrderInputsReducer,
});
